import { route, tag, type PageTour } from '../pageTour';

export const dashboardTour: PageTour = {
  id: 'page-dashboard',
  version: 2,
  title: 'All Sites Dashboard',
  summary: 'Every site\'s figures added together: alerts, watch lists, presence and system health.',
  match: route('/'),
  steps: [
    {
      target: tag('dashboard-board-customize'),
      title: 'Customize layout',
      description: 'Move, resize, hide or bring back cards so the board shows what matters to you. Your layout is saved to your account.',
      side: 'bottom',
    },
    {
      target: tag('dashboard-board-refresh'),
      title: 'Refresh',
      description: 'Reload every card now. The board also updates itself every few seconds.',
      side: 'bottom',
    },
    {
      target: tag('dashboard-board-cards'),
      title: 'All your sites at a glance',
      description: 'Each card adds up one subject across every online site, such as alerts, watch-list sightings, presence or system health. Click an item to see its details, or the arrow on a card to open the full page. If a site could not be read, a red note above the cards says which one.',
      side: 'top',
    },
  ],
};
